import axios from 'axios';

let cachedNonce = null;

const getNonce = async (rest) => {
	if (cachedNonce) return cachedNonce;
	const response = await axios.post(rest.uploadNonceUrl);
	cachedNonce = response?.data?.nonce || null;
	return cachedNonce;
};

export const uploadFileToServer = async (file, config, rest, uploadSession, updateProgress) => {
	const nonce = await getNonce(rest);
	const formData = new FormData();
	formData.append('file', file);
	formData.append('field_id', String(config.fieldID));
	formData.append('upload_session', uploadSession);

	const response = await axios.post(rest.uploadFileUrl, formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
			'X-FRM-Nonce': nonce,
		},
		onUploadProgress: (event) => {
			const total = event.total || file.size;
			if (!total) {
				return;
			}

			const percent = Math.round((event.loaded / total) * 100);
			updateProgress(percent);
		},
		maxBodyLength: Infinity,
		maxContentLength: Infinity,
	});

	return response?.data?.data || null;
};

export const deleteFileFromServer = async (config, rest, fileMetadata, uploadSession) => {
	const nonce = await getNonce(rest);
	const response = await axios.delete(rest.deleteFileUrl, {
		headers: {
			'X-FRM-Nonce': nonce,
		},
		data: {
			field_id: config.fieldID,
			storage_key: fileMetadata.storageKey,
			upload_session: uploadSession,
		},
	});

	return response?.data?.data || null;
};
